import { render, staticRenderFns } from "./AddChatUser.vue?vue&type=template&id=c33dd51e&scoped=true&"
import script from "@/components/chat/AddChatUser.ts?vue&type=script&lang=ts&"
export * from "@/components/chat/AddChatUser.ts?vue&type=script&lang=ts&"
import style0 from "@/components/chat/add-chat-user.scss?vue&type=style&index=0&id=c33dd51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33dd51e",
  null
  
)

export default component.exports